
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

console.log("AVUS WebApp initializing...");

const mountApp = () => {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    console.error("Critical Error: Root element '#root' not found in DOM.");
    return;
  }

  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log("AVUS WebApp successfully mounted.");
  } catch (error) {
    console.error("AVUS WebApp failed to mount:", error);
  }
};

// Check for ready state or wait for DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApp);
} else {
  mountApp();
}
